import api from "../../../../../BasicComponent/Service/api";
import { COMPORT_CONFIGURATION_URL } from "../../../../utils/constService";

export const fetchComportConfiguration = (params = {}) => {
  return api.get(`${COMPORT_CONFIGURATION_URL}/get-all`, { params });
};
export const fetchComportConfigurationForFilter = () => {
  return api.get(`${COMPORT_CONFIGURATION_URL}/get-all`);
};
export const postComportConfiguration = (data) => {
  return api.post(COMPORT_CONFIGURATION_URL, data);
};

export const putComportConfiguration = (data, comportConfigurationId) => {
  return api.put(
    `${COMPORT_CONFIGURATION_URL}/${comportConfigurationId}`,
    data
  );
};

export const deleteComportConfiguration = (comportConfigurationId) => {
  return api.delete(`${COMPORT_CONFIGURATION_URL}/${comportConfigurationId}`);
};
